function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { j as o } from "./index.es33.js";
import { memo as y, useState as m, useEffect as v, useCallback as R } from "react";
import "./index.es133.js";
import "react-dom";
import "./index.es134.js";
import { TimeZoneDate as S } from "./index.es506.js";
import { Month as u } from "./index.es523.js";
import { MonthYearPicker as x } from "./index.es524.js";
import { Periods as P } from "./index.es525.js";
import { RangeHeader as b } from "./index.es526.js";
import j from "./index.es527.js";
var z = /*#__PURE__*/y(function (_ref) {
  var t = _ref.dates,
      l = _ref.onSelect,
      p = _ref.isDayDisabled,
      M = _ref.onHover;

  var _m = m(function () {
    return t !== null && t !== void 0 && t[1] ? new Date(t[1]) : new S();
  }),
      _m2 = _slicedToArray(_m, 2),
      n = _m2[0],
      c = _m2[1],
      _m3 = m(null),
      _m4 = _slicedToArray(_m3, 2),
      s = _m4[0],
      d = _m4[1],
      _m5 = m("dates"),
      _m6 = _slicedToArray(_m5, 2),
      r = _m6[0],
      f = _m6[1],
      _m7 = m("dates"),
      _m8 = _slicedToArray(_m7, 2),
      a = _m8[0],
      h = _m8[1],
      i = new Date(new Date(new Date(n).setDate(1)).setMonth(n.getMonth() - 1));

  v(function () {
    if (t && !s && (t[0] || t[1])) {
      var e = new Date(t[0] || t[1]);
      e.getFullYear() === n.getFullYear() && (e.getMonth() === n.getMonth() || e.getMonth() === i.getMonth()) || c(new Date(e.setMonth(e.getMonth() + 1)));
    }

    t || d(null);
  }, [t]);

  var g = function g(e) {
    if (s) return l === null || l === void 0 ? void 0 : l(s.getTime() < e.getTime() ? [s, e] : [e, s]);
    l !== null && l !== void 0 && l([e, null]), d(e);
  },
      w = R(function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    return function (D) {
      c(e ? D : new Date(new Date(D).setMonth(D.getMonth() + 1))), f("dates"), h("dates");
    };
  }, []);

  return o.jsxs("div", {
    className: j.wrapper,
    children: [o.jsx(P, {
      onSelect: l
    }), o.jsxs("div", {
      children: [o.jsx(b, {
        setViewDate: c,
        setSecondaryMode: h,
        setPrimaryMode: f,
        secondViewDate: i,
        secondaryMode: a,
        primaryMode: r,
        viewDate: n
      }), o.jsxs("div", {
        className: j.body,
        children: [a === "dates" && o.jsx(u, {
          selectedRange: t && {
            start: t === null || t === void 0 ? void 0 : t[0],
            end: t === null || t === void 0 ? void 0 : t[1]
          },
          isDateDisabled: p,
          onDateHover: function onDateHover(e) {
            return M === null || M === void 0 ? void 0 : M(e);
          },
          onSelectDate: g,
          date: i
        }), a !== "dates" && o.jsx(x, {
          onSelect: w(!1),
          date: i,
          type: a
        }), r === "dates" && o.jsx(u, {
          selectedRange: t && {
            start: t === null || t === void 0 ? void 0 : t[0],
            end: t === null || t === void 0 ? void 0 : t[1]
          },
          isDateDisabled: p,
          onDateHover: function onDateHover(e) {
            return M === null || M === void 0 ? void 0 : M(e);
          },
          onSelectDate: g,
          date: n
        }), r !== "dates" && o.jsx(x, {
          onSelect: w(!0),
          date: n,
          type: r
        })]
      })]
    })]
  });
});
export { z as RangeDatePicker };